/**
 * Tooltip Help Content for Audit History Drawer
 */
export const auditHistoryDrawerContent = {
  UPDATED_BY: 'User who made this update',
  UPDATED_DATE: 'Date/Time the update was made',
  FIELD: 'This indicates the data field which was changed/created',
  FROM: 'This is the previous value for the given field',
  TO: 'The value the field was updated to on this date/time',
}

export const venueTemplateHelpContent = {
  ADDRESS: 'Address of the live location for auction',
  ADDRESS_DESCRIPTION:
    'This field describes to bidders where they may physically bid at a particular courthouse/ballroom/venue',
  AUCTION_AUCTIONEER:
    'Indicates if ADC is designated to cry the sale (or alternatively if it is a "marketing" asset); this value is used to assign on venue assignment at the asset level. A value of "Yes" indicates ADC shall cry the sale',
  AUCTION_START_DAY: 'Auction Start Day of Week',
  AUCTION_END_DAY: 'Templated Auction End Date (to be relevant to Event Date)',
  BID_START_TIME: 'Bid Start Time',
  BID_END_TIME: 'Templated Bidding Start Date',
  EVENT_TYPE:
    'Indicates if a venue can be used for either Trustee and/or Non-Trustee events/campaigns',
  WEB_LIVE_STATUS:
    'This indicates if the venue should be made immediately active and available upon creation',
  REGISTRATION_TIME: 'Time registration is scheduled to begin (Local Time)',
  TEMPLATE_NAME: 'Name of venue template',
  TEMPLATE_STATUS: 'Indicates if this venue template is eligible for use',
  VENUE_CLASSIFICATION:
    'Indicates if a venue is tagged for continued usage or not.  (Conversion means the venue should not be used for new sales)',
  VENUE_NAME: 'Name of venue/location/description',
  VENUE_SETTING:
    'Indicates the setting of the venue including whether it is to occur at the house itself.',
  VENUE_TITLE: 'Title of venue used for ADC',
  VENUE_TYPE:
    'This indicates if the assigned group of listings will be auctioned either on Online Bidding [on ADC], Live in person at a physical location, or by a 3rd party (in which case, ADC is primarily used for marketing only)',
  VENUE_URL: 'URL for the site venue. i.e. Hotel URL or Courthouse URL',
  IS_MINIMUM_BID_ENABLED:
    'Designates a listing group where any bid wins. The starting bid is equal to the reserve for this auction',
}

export const venueHelpContent = {
  VENUE_TITLE: 'Title of venue used for ADC',
  VENUE_NAME: 'Name of venue/location/description',
  VENUE_TYPE:
    'Indicates if the assets will be auctioned online or live in person',
  VENUE_CODE:
    'This is the venue "code" as used by MLH, not to be confused with the internal database unique id for venues',
  VENUE_URL: 'URL for the site venue. i.e. Hotel URL or Courthouse URL',
  ADDRESS: 'Address of the live location for auction',
  WEB_LIVE_STATUS:
    'Indicates if this is/was created in MLH having the Active and Available flags set to Yes or No',
  HOLDING_VENUE:
    'This flag indicates that the venue will be used as a placeholder for listings while they are staged to be put into an actual bucket',
  AUCTION_START_DATE: 'Auction Start Date',
  AUCTION_END_DATE: 'Auction End Date',
  REGISTRATION_TIME: 'Time at which registration starts',
  BID_START_TIME: 'Time at which bidding starts',
  BID_END_TIME: 'Time at which bidding ends',
  EVENT_ID: 'This indicates the event currently being used to add the venue.',
  ESTIMATED_ATTENDANCE:
    'Headquarters estimated count of bidders to attend the auction',
  STATE: 'State Code (e.g. CA, AZ)',
}

export const eventTemplateHelpContent = {
  EVENT_TEMPLATE_NAME: 'Administrator chosen internal template name',
  TRUSTEE_SALE:
    'Identifies if the campaign is intended for trustee/foreclosure assets',
  EVENT_TYPE:
    'Identifies if the assets in this group will be auctioned by ADC online, live in person or by a 3rd party entity (marketing only).',
  EVENT_NAME: 'Internal Event/Campaign Name/Description',
  EVENT_TITLE: 'Auction.com Campaign/Event Display name',
  FORCE_ONLINE_DISPLAY:
    'Flag that assets will displayed to have some form of online bidding which may or may not be on ADC',
  LISTING_GROUP_REQUIRED:
    'Indicates if users are required to have an Item Number (REDC ID) for assigning to an event; Venue required for asset assignment',
  COMING_SOON: 'Enables users to create campaigns without Dates',
  LIVE_QUAL:
    'This flag indicates if the listings part of this event are expected to have real time seller participation in the auction',
  WEB_LIVE_STATUS:
    'This indicates if the venue should be made immediately active and available upon creation',
  PRESALE:
    'Denotes if listings in this event are eligible for presale while taking into consideration the seller preference (seller level presale setting)',
  STATUS: 'Indicates if this event template is eligible for use',
  SEARCH_AND_ADD: 'Search by Template Name, State, County',
  MISMATCH_VENUE_TYPE: 'Mismatch Venue Type',
  MISMATCH_TRUSTEE_SALE: 'Mismatch Trustee Sale',
}

export const eventHelpContent = {
  CAMPAIGN_ID: 'Event Code / Auction number (ex. O-1000)',
  CAMPAIGN_START_DATE:
    'This value indicates the start of the campaign or the day',
  WEB_LIVE_STATUS:
    'Determines if the event should be both Active and Available (or not)',
  SEARCH_BY_TEMPLATE_NAME: 'Search by Template Name',
  END_TIME_INTERVAL: {
    TITLE: 'Leave blank when creating to use the default settings below:',
    REO_ONLINE: 'REO Online = 25',
    TRUSTEE_ONLINE: 'Trustee Online = 35',
  },
}

export const morpheusLogsDrawerContent = {
  TRANSACTION_ID: 'Morpheus internal transaction id',
  ENDPOINT: 'This is the endpoint that was used',
  STATUS: 'Indicates Success or Failure (error)',
  MESSAGE:
    'Response indicating specific error(s) when available for a given integration issue',
  PAYLOAD: 'This is the raw API data sent to Morpheus',
  INTERNAL_IDS:
    'This contains a raw array of internal ids to Morpheus related to the transaction',
  EXTERNAL_IDS:
    'This contains a raw array of external ids to the external system related to the transaction',
  TRANSACTION_DATE: 'Date of Transaction',
  CREATED_BY: 'User originating the transaction (sometimes system)',
  UPDATED_BY: 'User updating the transaction (sometimes system)',
}
